import React, { Component } from 'react';
import RegistrationSelectionView from './RegistrationSelectionView';
import queryString from 'query-string';
import { url } from '../../../Server/url/GlobalUrl';



class ResistrationSelectionComponent extends Component {
    state = {
        modal_show : false,
        authResponse : '',
    }
    hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }

    render() {
        return (<RegistrationSelectionView
				authResponse = {this.state.authResponse}
				modal_show = {this.state.modal_show}
				hideCustomModal = {this.hideCustomModal}
        	/>)
    }
}

export default ResistrationSelectionComponent;